import type { EUROPACE_INSURED_RISK } from 'cpool-constants';
import { EUROPACE_INSURED_RISKS } from 'cpool-constants';

// NOTE: the order in this array is the order in which the residual debt insurance will be displayed
const orderResidualDebtInsurance = [
    EUROPACE_INSURED_RISKS.LEBEN,
    EUROPACE_INSURED_RISKS.ARBEITSUNFAEHIGKEIT,
    EUROPACE_INSURED_RISKS.ARBEITSLOSIGKEIT,
] as const;

const sortResidualDebtInsurance = (a: EUROPACE_INSURED_RISK, b: EUROPACE_INSURED_RISK) => {
    return orderResidualDebtInsurance.indexOf(a) - orderResidualDebtInsurance.indexOf(b);
};

const filterResidualDebtInsurance = (residualDebtInsurance: string): residualDebtInsurance is EUROPACE_INSURED_RISK => {
    return Object.values(EUROPACE_INSURED_RISKS).includes(residualDebtInsurance as EUROPACE_INSURED_RISK);
};

// NOTE: this might need to be changed to a more generic solution in the future
const mapResidualDebtInsurance = (residualDebtInsurance: EUROPACE_INSURED_RISK): string | null => {
    switch (residualDebtInsurance) {
        case EUROPACE_INSURED_RISKS.LEBEN:
            return 'Todesfall';
        case EUROPACE_INSURED_RISKS.ARBEITSUNFAEHIGKEIT:
            return 'Arbeitsunfähigkeit';
        case EUROPACE_INSURED_RISKS.ARBEITSLOSIGKEIT:
            return 'Arbeitslosigkeit';
        default:
            return null;
    }
};

export const formatResidualDebtInsurance = (applicantResidualDebtInsurance: Array<string> | null | undefined) => {
    if (!applicantResidualDebtInsurance) return '';
    const residualDebtApplicant1 = applicantResidualDebtInsurance
        .filter(filterResidualDebtInsurance)
        .sort(sortResidualDebtInsurance)
        .map(mapResidualDebtInsurance)
        .filter((insurance) => insurance !== null);

    if (residualDebtApplicant1.length === 0) return 'nicht enthalten';
    return residualDebtApplicant1.join(', ');
};
